import { render, staticRenderFns } from "./LotStartPrice.vue?vue&type=template&id=9990640e&scoped=true"
import script from "./LotStartPrice.vue?vue&type=script&lang=js"
export * from "./LotStartPrice.vue?vue&type=script&lang=js"
import style0 from "./LotStartPrice.vue?vue&type=style&index=0&id=9990640e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9990640e",
  null
  
)

export default component.exports